var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4383 11.0499L12.2483 20.2399C11.1225 21.3658 9.59552 21.9983 8.00334 21.9983C6.41115 21.9983 4.88418 21.3658 3.75834 20.2399C2.63249 19.1141 2 17.5871 2 15.9949C2 14.4027 2.63249 12.8758 3.75834 11.7499L12.9483 2.55992C13.6989 1.80936 14.7169 1.3877 15.7783 1.3877C16.8398 1.3877 17.8578 1.80936 18.6083 2.55992C19.3589 3.31048 19.7806 4.32846 19.7806 5.38992C19.7806 6.45138 19.3589 7.46936 18.6083 8.21992L9.40834 17.4099C9.03306 17.7852 8.52406 17.996 7.99334 17.996C7.46261 17.996 6.95362 17.7852 6.57834 17.4099C6.20306 17.0346 5.99222 16.5256 5.99222 15.9949C5.99222 15.4642 6.20306 14.9552 6.57834 14.5799L15.0683 6.09992",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttached);
export default __webpack_public_path__ + "static/media/attached.cce54d4a1088e3d85316ea50e42f4bc7.svg";
export { ForwardRef as ReactComponent };